import React, { useState, useEffect } from "react";
import moment from "moment";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
// mui
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
// component
import Passengers from "./Passengers";
import CalendarComponent from "./CalendarComponent";
// React icons
import { HiArrowsRightLeft } from "react-icons/hi2";
// React Bootstrap
import Dropdown from "react-bootstrap/Dropdown";
// API
import { requestInfo } from "../../../actions/buses";
// Redux
import language from "../../../language";
import { useDispatch, useSelector } from "react-redux";
import { getPackages } from "../../../actions/trips";

const PackageForm = ({ service, packageTrip }) => {
  let history = useHistory();
  const dispatch = useDispatch();
  let languageSelectedEnglish =
    sessionStorage.getItem("language") === "english" ||
    !sessionStorage.getItem("language")
      ? true
      : false;

  const [formData, setFormData] = useState({
    from: "",
    to: "",
    date: moment().format("YYYY-MM-DD"),
  });
  const CityNames = useSelector((state) => state?.buses?.allCities);
  const [departureDate, setDepartureDate] = useState(
    moment().format("DD MMM YY")
  );
  const [returnDate, setReturnDate] = useState(moment().format("DD MMM YY"));
  const [infantCount, setInfantCount] = useState(0);
  const [childCount, setChildCount] = useState(0);
  const [adultCount, setAdultCount] = useState(1);
  const [totalPassenger, setTotalPassenger] = useState(0);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showPassengerDropdown, setShowPassengerDropdown] = useState(false);
  const [requestInfor, setRequestInfor] = useState({
    from: "",
    to: "",
    departureDate: moment().format("YYYY-MM-DD"),
    returnDate: moment().format("YYYY-MM-DD"),
    infantCount: infantCount,
    childCount: childCount,
    adultCount: adultCount,
    totalPassenger: 0,
    tripType: service,
  });
  const [departureDayName, setDepartureDayName] = useState("");

  useEffect(() => {
    if (requestInfor.departureDate) {
      const dayName = moment(requestInfor.departureDate).format("dddd");
      setDepartureDayName(dayName);
    }
  }, [requestInfor.departureDate]);

  useEffect(() => {
    setRequestInfor({
      from: formData.from,
      to: formData.to,
      departureDate: departureDate,
      returnDate: returnDate,
      totalPassenger: totalPassenger,
      tripType: service,
      infantCount: infantCount,
      childCount: childCount,
      adultCount: adultCount,
    });
  }, [
    formData,
    departureDate,
    adultCount,
    childCount,
    infantCount,
    returnDate,
    totalPassenger,
    service,
  ]);

  useEffect(() => {
    setTotalPassenger(infantCount + childCount + adultCount);
  }, [infantCount, childCount, adultCount]);

  function handleChange(event, value) {
    const name = event.target.name || event.target.id;
    const newValue = value ? value.cityName : event.target.value;

    setFormData({
      ...formData,
      [name]: newValue,
    });
  }

  const searchBusSbmit = async () => {
    const { from, to, departureDate, totalPassenger, tripType } = requestInfor;

    // Check 'from' is not empty
    if (!from) {
      Swal.fire({
        icon: "error",
        title: "Missing Information",
        text: "Please enter Departure city",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK",
        customClass: {
          title: "swal-title",
          content: "swal-text",
        },
      });
      return;
    }

    // If tripType is "Visa Package", 'to' must not be empty
    if (tripType === "Visa Package" && !to) {
      Swal.fire({
        icon: "error",
        title: "Missing Information",
        text: "Please enter Destination city for Visa Package",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK",
        customClass: {
          title: "swal-title",
          content: "swal-text",
        },
      });
      return;
    }

    // Check departureDate is not empty
    if (!departureDate) {
      Swal.fire({
        icon: "error",
        title: "Missing Information",
        text: "Please select a Departure Date",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK",
        customClass: {
          title: "swal-title",
          content: "swal-text",
        },
      });
      return;
    }

    // Check totalPassenger is not zero
    if (totalPassenger === 0) {
      Swal.fire({
        icon: "error",
        title: "Passenger Count Missing",
        text: "Please select at least one passenger",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK",
        customClass: {
          title: "swal-title",
          content: "swal-text",
        },
      });
      return;
    }

    // All validations passed, proceed with dispatches
    dispatch(requestInfo(requestInfor));
    dispatch(getPackages(requestInfor));

    history.push(`/client/packages`);
  };

  const getFilteredCities = (service) => {
    if (service === "Umrah") {
      return CityNames.filter((city) => city.cityName !== "Makkah");
    }
    if (service === "Madinah Ziyarah") {
      return CityNames.filter((city) => city.cityName !== "Madinah");
    }
    if (service === "Umrah & Madinah Ziyarah") {
      return CityNames.filter(
        (city) => city.cityName !== "Makkah" && city.cityName !== "Madinah"
      );
    }
    return CityNames; // default case
  };

  const fromOptions =
    service === "Visa Package"
      ? CityNames.filter((city) => city.cityName !== requestInfor.to)
      : getFilteredCities(service);

  const toOptions =
    service === "Visa Package"
      ? CityNames.filter((city) => city.cityName !== requestInfor.from)
      : CityNames;

  return (
    <>
      <Grid
        item
        xl={12}
        lg={12}
        md={12}
        flexDirection="column"
        style={{ marginTop: "10px" }}
      >
        <div className="form">
          <div className="homeFromToOuter">
            <Grid
              className={`form-each-box relative homeSelect ${
                service !== "Visa Package" ? "widthhundred" : ""
              }`}
              paddingLeft="0"
              paddingRight="0"
            >
              <Autocomplete
                className="locationSelect"
                disablePortal
                id="from"
                options={fromOptions}
                sx={{ width: "100%" }}
                value={
                  CityNames.find(
                    (city) => city.cityName === requestInfor.from
                  ) || null
                }
                onChange={(event, newValue) => {
                  handleChange({
                    target: {
                      name: "from",
                      value: newValue ? newValue.cityName : "",
                    }, // ✅ only city saved in state
                  });
                }}
                getOptionLabel={(option) => option.cityName} // ✅ input shows only city
                renderOption={(props, option) => (
                  <li {...props}>
                    <span className="cityfontSize">{option.cityName}</span>,{" "}
                    {option.countryShort}{" "}
                    {/* ✅ dropdown shows City, countryShort */}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    cityName={languageSelectedEnglish ? "From" : language.from}
                    name="from"
                    required
                  />
                )}
              />
            </Grid>
            {service === "Visa Package" && (
              <Grid item xs={1} alignSelf="center" className="arrowBetFromTo">
                <HiArrowsRightLeft className="arrowdirection" />
              </Grid>
            )}
            {service === "Visa Package" && (
              <Grid
                className="form-each-box homeSelect"
                paddingLeft="0"
                paddingRight="0"
              >
                <Autocomplete
                  className="locationSelect"
                  disablePortal
                  id="to"
                  options={toOptions}
                  sx={{ width: "100%" }}
                  value={
                    CityNames.find(
                      (city) => city.cityName === requestInfor.to
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleChange({
                      target: {
                        name: "to",
                        value: newValue ? newValue.cityName : "",
                      }, // ✅ only city saved in state
                    });
                  }}
                  getOptionLabel={(option) => option.cityName} // ✅ input shows only city
                  renderOption={(props, option) => (
                    <li {...props}>
                      <span className="cityfontSize">{option.cityName}</span>,{" "}
                      {option.countryShort}{" "}
                      {/* ✅ dropdown shows City, countryShort */}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      cityName={languageSelectedEnglish ? "To" : language.to}
                      name="to"
                      required
                    />
                  )}
                />
              </Grid>
            )}
          </div>
          <Grid
            item
            xs={12}
            className="form-each-box"
            width="100%"
            display="block"
            paddingLeft="0"
            paddingRight="0"
            style={{ marginTop: "15px" }}
          >
            <Dropdown
              show={showDropdown}
              onToggle={(isOpen) => setShowDropdown(isOpen)}
            >
              <Dropdown.Toggle
                variant="success"
                id="dropdown-passenger"
                onClick={() => setShowDropdown(!showDropdown)}
              >
                <Grid
                  container
                  xs={12}
                  justifyContent="space-between"
                  className="timing-wrapper"
                >
                  <Grid item xs={12} align="center">
                    <p className="tour-title">
                      {languageSelectedEnglish
                        ? "Departure Date"
                        : language.departureDate}
                    </p>
                    <p className="tour-date">{departureDate}</p>
                    <p className="tour-day">{departureDayName}</p>
                  </Grid>
                </Grid>
              </Dropdown.Toggle>
              <Dropdown.Menu className="dateSelectDropdown">
                <CalendarComponent
                  departureDate={departureDate}
                  setDepartureDate={setDepartureDate}
                  returnDate={returnDate}
                  setReturnDate={setReturnDate}
                  isPackage={true}
                  onClose={() => setShowDropdown(false)}
                  noOption={true}
                  setRequestInfor={setRequestInfor}
                  requestInfor={requestInfor}
                />
              </Dropdown.Menu>
            </Dropdown>
            <Grid item xs={12} className="passenger-wrap" marginTop="10px">
              <p className="form-heading">
                {languageSelectedEnglish ? "Passengers" : language.passengers}
              </p>
              <Dropdown
                show={showPassengerDropdown}
                onToggle={(isOpen) => setShowPassengerDropdown(isOpen)}
              >
                <Dropdown.Toggle
                  variant="success"
                  id="dropdown-passenger"
                  onClick={() =>
                    setShowPassengerDropdown(!showPassengerDropdown)
                  }
                >
                  <input
                    name="input"
                    type="text"
                    value={
                      infantCount && childCount && adultCount === 0
                        ? ""
                        : `${infantCount} ${
                            languageSelectedEnglish
                              ? "Infants"
                              : language.infants
                          } , ${childCount} ${
                            languageSelectedEnglish
                              ? "Children"
                              : language.children
                          }, ${adultCount} ${
                            languageSelectedEnglish ? "Adults" : language.adults
                          }`
                    }
                    placeholder={
                      languageSelectedEnglish
                        ? languageSelectedEnglish
                          ? "Not Selected"
                          : language.notSelected
                        : language.notSelected
                    }
                    read-only
                    className="form-input-text"
                  ></input>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Passengers
                    infantCount={infantCount}
                    setInfantCount={setInfantCount}
                    childCount={childCount}
                    setChildCount={setChildCount}
                    adultCount={adultCount}
                    setAdultCount={setAdultCount}
                    onClose={() => setShowPassengerDropdown(false)}
                  />
                </Dropdown.Menu>
              </Dropdown>
            </Grid>
          </Grid>
          <Grid item xs={12} align="center" className="homeSearch">
            <button
              type="submit"
              className="form-submit-button"
              onClick={searchBusSbmit}
            >
              {languageSelectedEnglish
                ? " Search Package"
                : language.searchBusTrips}
            </button>
            {/* </Link> */}
          </Grid>
        </div>
      </Grid>
    </>
  );
};

export default PackageForm;
